import confirmedIcon from '@assets/images/lock.png';
import checkIcon from '@assets/svgs/check.svg';
import closeIcon from '@assets/svgs/close.svg';
import EsfirusTable from '@components/ui/Table/EsfirusTable';
import { constants, rolesSupervisor } from '@helpers/constants';
import { dateDifferenceHours, dateFormat } from '@helpers/utils';
import { configurationService } from '@services/configApp';
import { useEffect, useState } from 'react';
import ModalDocuments from '@screens/TrackHorasList/components/ModalDocuments/ModalDocuments';
import './Table.scss';

export default function EsfirusFichajeTable(props: EsfirusFichajeTableProps) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedFichaje, setSelectedFichaje] = useState<number>(0);

  useEffect(() => {}, [
    props.partes,
    props.rol,
    props.onCheckRow,
    props.pendingSelected,
    props.seletedAll,
  ]);
  const columns = [
    {
      name: 'Empresa',
      keymap: '_id',
      showDocument: true,
      order: true,
      notShowEdit: true,
      width: 150,
      handleDocument: (row: any) => {
        setSelectedFichaje(row.id);
        setOpenModal(true);
      },
    },
    {
      name: 'Empleado',
      keymap: 'nombre_empleado',
      order: true,
      width: 150,
    },
    {
      name: 'Fecha entrada',
      keymap: 'dateIn',
      parse: (d: string) => dateFormat(d),
      order: true,
      width: 70,
    },
    {
      name: 'Fecha salida',
      keymap: 'dateOut',
      parse: (d: string, row: any) => {
        if (!d) return '-';
        else {
          const extra = row.extra ? JSON.parse(row.extra) : {};
          return `${dateFormat(d)}${extra.automaticExit ? ' (Auto)' : ''}`;
        }
      },
      order: true,
      width: 70,
    },
    {
      name: 'Horas',
      keymap: 'duration',
      parse: (d: number) => (!d ? '-' : Number(d).toFixed(2)),
      order: true,
      width: 50,
    },
    {
      name: 'Ubicación entrada',
      keymap: 'gpsIn',
      parse: (d: string) => JSON.parse(d),
      width: 130,
    },
    {
      name: 'Ubicación salida',
      keymap: 'gpsOut',
      parse: (d: string) => JSON.parse(d),
      width: 130,
    },
  ];

  const parseRows = (rows: any) => {
    return rows.map((el: any) => {
      const empresa: any = props.empresas?.find(
        (e: any) => e.Empresa == el.empresa
      );

      return {
        ...el,
        tipo: el.tipo === '1' ? 'A' : 'O',
        validadoImg: setValidation(el.validado),
        _id: (empresa?.Nombre ?? el.empresa) + '-' + el.id,
        nombreObra2: `${el?.idObra} - ${el.nombreObra}`,
        duration: !el.dateOut
          ? null
          : dateDifferenceHours(el.dateOut, el.dateIn),
      };
    });
  };

  const setValidation = (type: number) => {
    const icons: any = {
      0: { icon: '', class: '', type },
      1: { icon: confirmedIcon, class: 'confimed-icon', type },
      2: { icon: checkIcon, class: 'validated-icon', type },
      3: { icon: closeIcon, class: 'rejected-icon', type },
    };

    return icons[type];
  };

  const { partesValidar } = configurationService.getConfigCabeceraParte();
  //si es es algun revisor, y la configuracion no es de cerrar dias y no es de cerrar partes, entonces se puede editar
  const editableRows =
    rolesSupervisor.includes(Number(props?.rol) as number) && partesValidar
      ? [constants.estadoParte.confirmado]
      : [];

  return (
    <>
      <EsfirusTable
        rows={parseRows(props?.partes)}
        columns={columns}
        editableRows={editableRows}
        validating={true}
        onCheckRow={props.onCheckRow}
        deleteReport={props?.deleteReport}
        onCheckAll={props.onCheckAll}
        onOpenEdit={props.onOpenEdit}
        pendingSelected={props.pendingSelected}
        seletedAll={props.seletedAll}
        download={props.download}
      />

      {openModal && (
        <ModalDocuments
          {...{
            ...{ open: openModal, setOpen: setOpenModal, selectedFichaje },
          }}
        />
      )}
    </>
  );
}

export interface EsfirusFichajeTablePropsOption {
  label: string;
  value: any;
}
export interface EsfirusFichajeTablePropsDownload {
  pdf: boolean;
  excel: boolean;
}
export interface EsfirusFichajeTableProps {
  partes?: [];
  empresas?: [];
  rol?: number;
  onCheckRow?: Function;
  onCheckAll?: Function;
  onOpenEdit?: Function;
  deleteReport?: Function;
  pendingSelected?: any;
  seletedAll?: boolean;
  download?: EsfirusFichajeTablePropsDownload;
}
